var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74951 3.12402C5.74951 3.02457 5.71 2.92918 5.63968 2.85886C5.56935 2.78853 5.47397 2.74902 5.37451 2.74902C5.27506 2.74902 5.17967 2.78853 5.10935 2.85886C5.03902 2.92918 4.99951 3.02457 4.99951 3.12402V5.87402C4.99951 6.00902 5.07151 6.13302 5.18851 6.19952L6.93851 7.19952C7.02466 7.24608 7.12559 7.25709 7.21975 7.23021C7.31391 7.20333 7.39382 7.14069 7.4424 7.05567C7.49098 6.97065 7.50438 6.87001 7.47974 6.77524C7.45509 6.68047 7.39436 6.5991 7.31051 6.54852L5.74951 5.65652V3.12402Z",
    fill: "#747B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0C2.4625 0 0 2.4625 0 5.5C0 8.5375 2.4625 11 5.5 11C8.5375 11 11 8.5375 11 5.5C11 2.4625 8.5375 0 5.5 0ZM0.75 5.5C0.75 4.24022 1.25044 3.03204 2.14124 2.14124C3.03204 1.25044 4.24022 0.75 5.5 0.75C6.75978 0.75 7.96796 1.25044 8.85876 2.14124C9.74955 3.03204 10.25 4.24022 10.25 5.5C10.25 6.75978 9.74955 7.96796 8.85876 8.85876C7.96796 9.74955 6.75978 10.25 5.5 10.25C4.24022 10.25 3.03204 9.74955 2.14124 8.85876C1.25044 7.96796 0.75 6.75978 0.75 5.5Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2f3c0a061346ecd21a893a3ce193de23.svg";
export { ForwardRef as ReactComponent };